module.exports = "https://coursera_assets.s3.amazonaws.com/images/4608e70d856d6f1b866705b1c06d797a.png";